import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import '@/components/globals/'
import * as VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)
import VueMask from 'v-mask'
Vue.use(VueMask)

import Login from '@/layouts/Login.vue';
import Default from '@/layouts/Default.vue';
import Noauth from '@/layouts/NoAuth.vue';
import Robo from '@/layouts/Robo.vue';

Vue.component('login-layout', Login);
Vue.component('default-layout', Default);
Vue.component('noauth-layout', Noauth);
Vue.component('robo-layout', Robo);

Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');